






























import { Vue, Component } from 'vue-property-decorator';
import Plant from "@/domainObjects/Plant";
import WipTicket from "@/domainObjects/wip/WipTicket";
import TicketService from "@/services/TicketService";
import Fields from "@/domainObjects/Fields";
import LoadingActions from "@/store/actions/loading";


@Component({
})
export default class PrintWipTicketTable extends Vue {

    private wipTickets:WipTicket[] = [];
    private fields:Fields[] = [];
    private totalRows:number = 0;
    private filter:string = '';
    private sortBy: string = '';
    private sortDesc: boolean = true;
    private isBusy = true;
    private plantCode: string = '0';

    constructor() {
        super();
        this.fields = [
            { key: 'wipTicketId', label: 'Ticket #', sortable: true, sortDirection: 'desc' },
            { key: 'productionOrderNum', label: 'Order Number', sortable: true, sortDirection: 'desc' },
            { key: 'qtyOnHold', label: 'QTY', sortable: true, sortDirection: 'desc'},
            { key: 'materialDesc', label: 'Material Description', sortable: true, sortDirection: 'desc' },
            { key: 'comments', label: 'Required', sortable: true, sortDirection: 'desc'},
            { key: 'daysOpen', label: 'Days Open', sortable: true, sortDirection: 'desc' },
            { key: 'plant.desc', label: 'Plant', sortable: true, sortDirection: 'desc' },
        ];

    }

    created(){
        this.plantCode = this.$route.query['plantCode'];
        this.totalRows = this.wipTickets.length;
        this.filter = this.$route.query['filter'];
        this.sortBy = this.$route.query['sortBy'];
        this.sortDesc = Boolean(this.$route.query["sortDesc"]);
        this.fetchWipTickets();
    }

    fetchWipTickets() {
        this.$store.dispatch(LoadingActions.LOADING, true);
        TicketService.getWipTickets().then((response) => {
            for ( let readWipTicket of response.data ) {
                let ticket = new WipTicket();
                ticket.initFromObject(readWipTicket);
                ticket.comments = this.formatLongString(ticket.comments);
                if (this.plantCode === "0" || this.plantCode === ""){
                    this.wipTickets.push(ticket);
                } else {
                    if (this.plantCode === ticket.plant.code){
                        this.wipTickets.push(ticket);
                    }
                }
            }
            this.toggleBusy();
            this.$store.dispatch(LoadingActions.LOADING, false);
        }).catch((error)=>{
        });
    }

    formatLongString(value){
        if (typeof value === 'string' && value.length > 60){
            return value.substring(0,59) + '...'
        }
        return value;
    }

    toggleBusy() {
        this.isBusy = !this.isBusy;
    }
}

